import api from './api';

const jobService = {
  getJobs: async (params = {}) => {
    const response = await api.get('/jobs', { params });
    return response.data;
  },

  getJobById: async (id) => {
    const response = await api.get(`/jobs/${id}`);
    return response.data;
  },

  searchJobs: async (params) => {
    const response = await api.get('/jobs/search', { params });
    return response.data;
  },

  getFeaturedJobs: async (limit = 10) => {
    const response = await api.get('/jobs/featured', { params: { limit } });
    return response.data;
  },

  getTrendingJobs: async (limit = 10) => {
    const response = await api.get('/jobs/trending', { params: { limit } });
    return response.data;
  },

  getSimilarJobs: async (id, limit = 5) => {
    const response = await api.get(`/jobs/${id}/similar`, { params: { limit } });
    return response.data;
  },

  getJobsByCompany: async (companyId, params = {}) => {
    const response = await api.get(`/jobs/company/${companyId}`, { params });
    return response.data;
  },

  saveJob: async (jobId) => {
    const response = await api.post(`/jobs/${jobId}/save`);
    return response.data;
  },

  unsaveJob: async (jobId) => {
    const response = await api.delete(`/jobs/${jobId}/save`);
    return response.data;
  },

  getSavedJobs: async (params = {}) => {
    const response = await api.get('/jobs/user/saved', { params });
    return response.data;
  },

  // Employer methods
  createJob: async (jobData) => {
    const response = await api.post('/jobs', jobData);
    return response.data;
  },

  updateJob: async (id, jobData) => {
    const response = await api.put(`/jobs/${id}`, jobData);
    return response.data;
  },

  deleteJob: async (id) => {
    const response = await api.delete(`/jobs/${id}`);
    return response.data;
  },
};

export default jobService;
